import React from 'react';

type Props = {
  wrongPid?: boolean | null;
  status?: string | null;
  disabled?: boolean;
  className?: string;
  onResubmit: () => void;
  onRelist: () => void;
};

function statusKey(status: string | null | undefined): string {
  return String(status || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
}

/** Shown above the status select while tp_wrong_pid is true. */
export function WrongPidRetryButton({
  wrongPid,
  status,
  disabled = false,
  className,
  onResubmit,
  onRelist,
}: Props) {
  if (wrongPid !== true) return null;
  const key = statusKey(status);
  const isVerified = key === 'verified';
  const isListed = key === 'list' || key === 'listed';
  if (!isVerified && !isListed) return null;
  const label = isVerified ? 'Resubmit' : 'Relist';
  return (
    <button
      type="button"
      className={className}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        if (disabled) return;
        if (isVerified) onResubmit();
        else onRelist();
      }}
    >
      {label}
    </button>
  );
}
